import { mapKeysToCamelCase } from '@skytech/utils'

import { get } from '@/util/auth'

import { API_ROUTE_SHOP_SETUP } from './api-routes'
import assetLocationResources from './asset-locations'

type CostObjectOriginal = {
  id: number
  code: string
  name: string
  employee_no: string
  customer_id: number
  department_name: string
  department_code: string
  email: string
  department_id?: number
}

const employeeResources = {
  getList: async (hasLocationsAccess: boolean) => {
    const shopSetup = await get<CostObjectOriginal[]>(API_ROUTE_SHOP_SETUP)
    const parsedShopSetup = mapKeysToCamelCase(shopSetup)
    const locations = hasLocationsAccess ? await assetLocationResources.getList() : []

    const userList = parsedShopSetup.map(co => ({
      id: co.id,
      name: co.name,
      code: co.code,
      email: co.email,
      departmentName: co.departmentName,
      departmentCode: co.departmentCode,
      employeeNo: co.employeeNo,
      customerId: co.customerId,
      isLocation: false,
      departmentId: co.departmentId,
    }))
    const locationList = locations.map(location => ({
      id: location.id,
      name: location.name || '',
      code: location.code,
      departmentName: location.department.name,
      departmentCode: location.department.code,
      customerId: location.customer.id,
      customerAddressId: location.customerAddress?.id,
      isLocation: true,
    }))

    const employees: {
      id: number
      name: string
      code: string
      departmentName: string
      departmentCode: string
      customerId: number
      isLocation: boolean
      employeeNo?: string
      customerAddressId?: number
      departmentId?: number
      email?: string
    }[] = [...userList, ...locationList]

    return { employees, userList, locationList }
  },
}

export default employeeResources

export type Employee = Awaited<ReturnType<typeof employeeResources.getList>>['employees'][number]
